import { Actions } from 'vuex-smart-module';
import { AxiosResponse } from 'axios';
import { DocsTemplates, ResponseStatuses } from '@/enums';
import { DocsTemplatesService } from '@/services/documents';
import { FiltersPagination } from '@/types';
import { SubpartnersService } from '../../../services';
import SubpartnersSalesGetters from './getters';
import SubpartnersSalesMutations from './mutations';
import SubpartnersSalesState from './state';

const subpartnersService = new SubpartnersService();

export default class SubpartnersSalesActions extends Actions<
  SubpartnersSalesState,
  SubpartnersSalesGetters,
  SubpartnersSalesMutations,
  SubpartnersSalesActions
> {
  async get_subpartners_sales(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<null> = {
        filters: null,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_SALES_LOADING(true);

      const { data, meta } = await subpartnersService.get_subpartners_sales(payload);

      this.mutations.SET_SUBPARTNERS_SALES(data);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    } finally {
      this.mutations.TOGGLE_SALES_LOADING(false);
    }
  }

  async send_subpartner_sales(file: File) {
    try {
      const { code = ResponseStatuses.Success.OK, data } = await subpartnersService.send_subpartner_sales(file);

      this.mutations.SET_FILE_UPLOAD_DETAILS(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_partner_sale_template() {
    try {
      const { data: { path } } = await new DocsTemplatesService().get_document_template(DocsTemplates.PARTNER_SALE);

      this.mutations.SET_DOC_TEMPLATE_LINK(path);
    } catch (error) {
      console.log(error);
    }
  }
}
